// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Shared value display in read-only rows ───────────────────── */
.org-modal-value {
  font-size: var(--fs-2xs);
  color: var(--text);
  display: flex;
  align-items: center;
  min-height: 28px;
}

.org-modal-value.mono {
  font-family: var(--mono);
}

/* Danger CTA pinned to left in modal footer */
.org-foot-left {
  margin-right: auto;
}

/* ── Ayuda modal ──────────────────────────────────────────────── */
.ayuda-intro {
  margin: 0 0 12px;
  font-size: var(--fs-ui);
  color: var(--text-secondary);
  line-height: 1.5;
}

.ayuda-grid {
  display: grid;
  gap: 10px;
}

.ayuda-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
}

.ayuda-label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--cream-deep);
  width: 64px;
  flex-shrink: 0;
}

.ayuda-value {
  font-size: var(--fs-ui);
  color: var(--text);
}

.ayuda-value.mono {
  font-family: var(--mono);
}

/* Dark bg variant for Ayuda (fixture uses dark background) */
[data-theme='dark'] .ayuda-label,
.dark .ayuda-label {
  color: var(--cream);
}

[data-theme='dark'] .ayuda-value,
.dark .ayuda-value {
  color: var(--ink-text);
}

/* ── Información de receptores table ─────────────────────────── */
.info-receptores-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--fs-2xs);
}

.info-receptores-table th,
.info-receptores-table td {
  padding: 8px 16px;
  text-align: left;
  border-bottom: 1px solid var(--border-soft);
}

.info-receptores-table th {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  background: var(--bg);
  font-weight: 500;
}

.info-receptores-table th.num,
.info-receptores-table td.num {
  text-align: right;
}

.info-receptores-table tbody tr:last-child td {
  border-bottom: none;
}

.info-receptores-date {
  font-family: var(--mono);
  font-size: var(--fs-xs);
  color: var(--text-secondary);
}

.info-receptores-resultado {
  font-family: var(--mono);
  font-size: var(--fs-xs);
}

/* ── Input error variant (reused from ReceptorModales) ───────── */
.form-input.input-error {
  border-color: var(--danger);
  outline-color: var(--danger);
}
`, "",{"version":3,"sources":["webpack://./src/shared/OrgModales/OrgModales.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;EACE,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,6DAA6D;AAC7D;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["/* ── Shared value display in read-only rows ───────────────────── */\n.org-modal-value {\n  font-size: var(--fs-2xs);\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  min-height: 28px;\n}\n\n.org-modal-value.mono {\n  font-family: var(--mono);\n}\n\n/* Danger CTA pinned to left in modal footer */\n.org-foot-left {\n  margin-right: auto;\n}\n\n/* ── Ayuda modal ──────────────────────────────────────────────── */\n.ayuda-intro {\n  margin: 0 0 12px;\n  font-size: var(--fs-ui);\n  color: var(--text-secondary);\n  line-height: 1.5;\n}\n\n.ayuda-grid {\n  display: grid;\n  gap: 10px;\n}\n\n.ayuda-row {\n  display: flex;\n  gap: 10px;\n  align-items: baseline;\n}\n\n.ayuda-label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--cream-deep);\n  width: 64px;\n  flex-shrink: 0;\n}\n\n.ayuda-value {\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n\n.ayuda-value.mono {\n  font-family: var(--mono);\n}\n\n/* Dark bg variant for Ayuda (fixture uses dark background) */\n[data-theme='dark'] .ayuda-label,\n.dark .ayuda-label {\n  color: var(--cream);\n}\n\n[data-theme='dark'] .ayuda-value,\n.dark .ayuda-value {\n  color: var(--ink-text);\n}\n\n/* ── Información de receptores table ─────────────────────────── */\n.info-receptores-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--fs-2xs);\n}\n\n.info-receptores-table th,\n.info-receptores-table td {\n  padding: 8px 16px;\n  text-align: left;\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.info-receptores-table th {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n  background: var(--bg);\n  font-weight: 500;\n}\n\n.info-receptores-table th.num,\n.info-receptores-table td.num {\n  text-align: right;\n}\n\n.info-receptores-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.info-receptores-date {\n  font-family: var(--mono);\n  font-size: var(--fs-xs);\n  color: var(--text-secondary);\n}\n\n.info-receptores-resultado {\n  font-family: var(--mono);\n  font-size: var(--fs-xs);\n}\n\n/* ── Input error variant (reused from ReceptorModales) ───────── */\n.form-input.input-error {\n  border-color: var(--danger);\n  outline-color: var(--danger);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
